import React from "react";
import { Flag } from "@litres/ui-kit/flags";
import { DROPDOWN_APP_LANGUAGES } from "../../constants";
import styles from "./DropdownLanguageItem.module.scss";

interface IDropdownLanguageItem {
  id: string;
  defaultActiveId: string;
}

export const DropdownLanguageItem = ({
  id,
  defaultActiveId,
}: IDropdownLanguageItem): JSX.Element => {
  const currentLang = DROPDOWN_APP_LANGUAGES.find(item => item.id === id);

  return (
    <div className={styles.dropdownItem}>
      <div className={styles.dropdownItem__content}>
        {currentLang?.content?.flag && (
          <Flag language={currentLang.content.flag} width={29} />
        )}
        <span className={styles.dropdownItem__title}>
          {currentLang?.content.title}
        </span>
      </div>
      {id !== defaultActiveId && (
        <div className={styles.dropdownItem__value}>
          <span>{currentLang?.value}</span>
        </div>
      )}
    </div>
  );
};
